/* global document */

/* eslint-disable no-param-reassign */
import type Participant from './Participant';
import Workano from '../index';

class Stream {
  htmlStream: MediaStream;

  participant: Participant | undefined;

  static detachStream(stream: MediaStream) {
    stream.getTracks()
      .filter((track: MediaStreamTrack) => track.enabled)
      .forEach((track: MediaStreamTrack) => track.stop());
  }

  constructor(htmlStream: MediaStream, participant?: Participant) {
    this.htmlStream = htmlStream;
    this.participant = participant;
  }

  attach(rawElement: HTMLVideoElement | null | undefined) {
    const element = rawElement || document.createElement('video');
    const isLocal = this.participant instanceof Workano.LocalParticipant;
    element.autoplay = true;
    element.srcObject = this.htmlStream;
    element.muted = isLocal;

    if (isLocal) {
      // Reverse local video
      element.style.transform = 'scale(-1, 1)';
    }

    element.onloadedmetadata = () => {
      const tracks = this.htmlStream ? this.htmlStream.getVideoTracks() : [];
      tracks.forEach((track: MediaStreamTrack & { loaded?: boolean }) => {
        track.enabled = true;
        track.loaded = true;
      });
    };

    return element;
  }

  detach() {
    Stream.detachStream(this.htmlStream);
  }

  hasVideo() {
    if (!this.htmlStream) {
      return false;
    }

    return this.htmlStream.getTracks().some(track => track.kind === 'video' && track.readyState !== 'ended');
  }

  get id() {
    return this.htmlStream ? this.htmlStream.id : null;
  }

}

export default Stream;
